<template>
  <iStyledCard title="Comment" width="fill" @click.prevent="">
    <template #description>
      <iColumn gap="small">
        <iRow gap="small" vertical-align="middle">
          <iText font-weight="strong">
            {{ entity.author_name }}
          </iText>
          <iText variant="subtle" font-size="small">
            {{ relativeCreatedAt }}
          </iText>
        </iRow>
        <iText
          v-bind="textOnlyAttributes"
          :style-overrides="textOnlyAttributes.textStyleOverrides"
        >
          {{ entity.message }}
        </iText>
        <iRow gap="small" vertical-align="middle">
          <iText font-size="small" variant="subtle">
            {{ entity.num_likes }} likes
          </iText>
          <iText font-size="small" variant="subtle">
            {{ entity.num_approved_replies }} replies
          </iText>
        </iRow>
      </iColumn>
    </template>
  </iStyledCard>
</template>

<script>
// Comment element preview. Previously imported `CommentThread` from
// `%/components/community/chatrooms/comments/CommentThread.vue` (outside
// the dynamic-component-editor directory tree) and pulled live data
// out of a broken `useConversationStore`. Both have been stripped:
// the canvas preview now renders the example entity inline using only
// VCL primitives, so the element stays self-contained inside the
// dynamic-component-editor directory per the editor's isolation rule.
import { TextElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/text-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import { CommentPageElementMixin } from "%/dynamic-component-editor/standard-pages/comment-page/comment-page-element-mixin";

export default {
  name: "Comment",
  mixins: [CommentPageElementMixin, TextElementMixin],
  elementPanelSettings: {
    displayName: "Comment",
    displayIcon: "list",
    elementGroup: "commentElements",
    elementType: "element",
  },
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
  ],
  computed: {
    // "X minutes ago" style string derived from the example entity's
    // `timestamp_created`. Kept inline rather than imported from a
    // utility to honour the dynamic-component-editor isolation rule.
    relativeCreatedAt() {
      const ts = this.entity?.timestamp_created;
      if (!ts) {
        return "";
      }
      const seconds = Math.max(1, Math.floor(Date.now() / 1000) - ts);
      if (seconds < 60) {
        return `${seconds}s ago`;
      }
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) {
        return `${minutes}m ago`;
      }
      const hours = Math.floor(minutes / 60);
      if (hours < 24) {
        return `${hours}h ago`;
      }
      const days = Math.floor(hours / 24);
      return `${days}d ago`;
    },
  },
};
</script>
